var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { v4 as uuidV4 } from 'uuid';
var AdvancedFilters = React.forwardRef(function (props, ref) {
    var id = useState(uuidV4().replace(/-/g, ''))[0];
    return (_jsxs("svg", __assign({ ref: ref }, props, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("mask", __assign({ id: "mask0_".concat(id), style: {
                    maskType: 'alpha'
                }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "20", height: "20" }, { children: _jsx("rect", { width: "20", height: "20", fill: "#D9D9D9" }) })), _jsx("g", __assign({ mask: "url(#mask0_".concat(id, ")") }, { children: _jsx("path", { d: "M9.16667 17.5V12.5H10.8333V14.1667H17.5V15.8333H10.8333V17.5H9.16667ZM2.5 15.8333V14.1667H7.5V15.8333H2.5ZM5.83333 12.5V10.8333H2.5V9.16667H5.83333V7.5H7.5V12.5H5.83333ZM9.16667 10.8333V9.16667H17.5V10.8333H9.16667ZM12.5 7.5V2.5H14.1667V4.16667H17.5V5.83333H14.1667V7.5H12.5ZM2.5 5.83333V4.16667H10.8333V5.83333H2.5Z", fill: "#2B3737" }) }))] })));
});
export default AdvancedFilters;
